import { createContext } from "react";
import { TransactionContextType } from "@/types/creditTransaction";

export const TransactionContext = createContext<TransactionContextType | null>(
    null,
);
